<template>
  <div v-if="kind" class="project-media-preview">
    <el-button size="mini" :loading="loading" @click="load">{{ url ? '重新加载预览' : kind === 'image' ? '查看图片' : '播放视频' }}</el-button>
    <img v-if="url && kind === 'image'" :src="url" :alt="file.displayName || '项目图片'" referrerpolicy="no-referrer" />
    <video v-if="url && kind === 'video'" :src="url" controls playsinline preload="metadata" />
  </div>
</template>
<script>
import { downloadProjectAsset } from '@/apis/project-team'
export default {
  props: { projectGuid: String, file: Object },
  data: () => ({ url: '', loading: false, epoch: 0 }),
  computed: { kind() { return /^image\//.test(this.file.mimeType || '') ? 'image' : /^video\//.test(this.file.mimeType || '') ? 'video' : '' } },
  watch: { projectGuid() { this.reset() }, 'file.assetGuid'() { this.reset() }, 'file.version'() { this.reset() } },
  beforeDestroy() { this.reset() },
  methods: {
    reset() { ++this.epoch; this.url = ''; this.loading = false },
    async load() {
      if (this.loading || !this.kind) return
      const epoch = ++this.epoch; this.loading = true
      try {
        // 只向原资产下载接口提交已保存的引用，预览不会创建订单或消费生成点数。
        const result = await downloadProjectAsset({ projectGuid: this.projectGuid, assetGuid: this.file.assetGuid, version: this.file.version })
        if (epoch !== this.epoch) return
        const parsed = new URL(result.url)
        if (parsed.protocol !== 'https:' || parsed.username || parsed.password) throw new Error('媒体预览地址无效')
        this.url = parsed.href
      } catch (error) { if (epoch === this.epoch) this.$message.error(error.message || '预览失败，请重新加载') }
      finally { if (epoch === this.epoch) this.loading = false }
    }
  }
}
</script>
<style scoped>
.project-media-preview{margin:8px 0}.project-media-preview img,.project-media-preview video{display:block;max-width:100%;max-height:480px;margin-top:10px;border-radius:8px}
</style>
